import { render } from "./AssignedTaskNamesPopup.vue?vue&type=template&id=1d76796f&ts=true"
import script from "./AssignedTaskNamesPopup.vue?vue&type=script&lang=ts"
export * from "./AssignedTaskNamesPopup.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__